import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ContentLoader from 'react-content-loader';
// apollo
import { Query, Mutation } from 'components/common/Query';
import { adopt } from 'react-adopt';
import { formatRoute } from 'react-router-named-routes';
// our components
import RouterContext from 'helpers/routerContext';
import { PERMISSION_GROUP_QUERY } from 'components/Permission/Update';
import { DELETE_PERMISSIONS_GROUP_MUTATION } from 'components/Permission/List';
import { PERMISSION } from 'routes/paths';
import Card from 'components/UI/Card/Card';
import CardBody from 'components/UI/Card/CardBody';
import PermissionDetails from './Details';

class PermissionGroupDetailsContainer extends Component {
  static contextType = RouterContext;

  constructor(props) {
    super(props);
    this.Compose = adopt({
      mutatePermissionDelete: this.permissionDelete,
      query: this.permissionGroup,
    });
  }

  /**
   * @description
   * User's query callback to compose with mutations
   * @param {*} render - Query's render props.
   */
  permissionGroup = ({ render }) => {
    const { id } = this.props;
    return (
      <Query
        query={PERMISSION_GROUP_QUERY}
        variables={{ id }}
        notifyOnNetworkStatusChange
        fetchPolicy="cache-and-network"
      >
        {({ data, loading }) => render({ data, loading })}
      </Query>
    );
  };

  /**
   * @description
   * Mutation callback to compose with list query.
   * @param {*} render - Mutation's render props.
   * @returns {*} Mutation component.
   */
  permissionDelete = ({ render }) => (
    <Mutation
      mutation={DELETE_PERMISSIONS_GROUP_MUTATION}
      onCompleted={this.permissionDeleteCompleted}
    >
      {handlePermissionDelete => render({ handlePermissionDelete })}
    </Mutation>
  );

  /**
   * @description
   * OnComplete delete mutation.
   * @param {*} errors - Mutation result.
   */
  permissionDeleteCompleted = async ({ errors }) => {
    const history = this.context;
    if (!errors) {
      history.push(formatRoute(PERMISSION.LIST));
    }
  };

  /**
   * @description
   * Render PermissionDetails component.
   *
   * @returns {*} Render PermissionDetails component.
   */
  render() {
    const { id } = this.props;
    return (
      <this.Compose>
        {({
          mutatePermissionDelete: { handlePermissionDelete },
          query: { data, loading },
        }) => {
          if (loading)
            return (
              <Card>
                <CardBody>
                  <ContentLoader height={554} width={489} speed={2}>
                    <path
                      // eslint-disable-next-line max-len
                      d="M39,25 L201.694581,25 C209.978853,25 216.694581,31.7157288 216.694581,40 L216.694581,42 C216.694581,50.2842712 209.978853,57 201.694581,57 L39,57 C30.7157288,57 24,50.2842712 24,42 L24,40 C24,31.7157288 30.7157288,25 39,25 Z M299.812808,33.5333333 L362.197044,33.5333333 C366.615322,33.5333333 370.197044,37.1150553 370.197044,41.5333333 C370.197044,45.9516113 366.615322,49.5333333 362.197044,49.5333333 L299.812808,49.5333333 C295.39453,49.5333333 291.812808,45.9516113 291.812808,41.5333333 C291.812808,37.1150553 295.39453,33.5333333 299.812808,33.5333333 Z M395.615764,33.5333333 L458,33.5333333 C462.418278,33.5333333 466,37.1150553 466,41.5333333 C466,45.9516113 462.418278,49.5333333 458,49.5333333 L395.615764,49.5333333 C391.197486,49.5333333 387.615764,45.9516113 387.615764,41.5333333 C387.615764,37.1150553 391.197486,33.5333333 395.615764,33.5333333 Z"
                      fill="#D8D8D8"
                    />
                    <path
                      // eslint-disable-next-line max-len
                      d="M30,118 L165.333333,118 C168.647042,118 171.333333,120.686292 171.333333,124 L171.333333,130.322767 C171.333333,133.636475 168.647042,136.322767 165.333333,136.322767 L30,136.322767 C26.6862915,136.322767 24,133.636475 24,130.322767 L24,124 C24,120.686292 26.6862915,118 30,118 Z M30,168.657061 L331.228346,168.657061 C334.542055,168.657061 337.228346,171.343352 337.228346,174.657061 L337.228346,180.979827 C337.228346,184.293536 334.542055,186.979827 331.228346,186.979827 L30,186.979827 C26.6862915,186.979827 24,184.293536 24,180.979827 L24,174.657061 C24,171.343352 26.6862915,168.657061 30,168.657061 Z M30,219.314121 L241.900262,219.314121 C245.213971,219.314121 247.900262,222.000413 247.900262,225.314121 L247.900262,231.636888 C247.900262,234.950596 245.213971,237.636888 241.900262,237.636888 L30,237.636888 C26.6862915,237.636888 24,234.950596 24,231.636888 L24,225.314121 C24,222.000413 26.6862915,219.314121 30,219.314121 Z M30,269.971182 L181.574803,269.971182 C184.888512,269.971182 187.574803,272.657473 187.574803,275.971182 L187.574803,282.293948 C187.574803,285.607657 184.888512,288.293948 181.574803,288.293948 L30,288.293948 C26.6862915,288.293948 24,285.607657 24,282.293948 L24,275.971182 C24,272.657473 26.6862915,269.971182 30,269.971182 Z M30,321.706052 L96.8871391,321.706052 C100.200848,321.706052 102.887139,324.392343 102.887139,327.706052 L102.887139,334.028818 C102.887139,337.342527 100.200848,340.028818 96.8871391,340.028818 L30,340.028818 C26.6862915,340.028818 24,337.342527 24,334.028818 L24,327.706052 C24,324.392343 26.6862915,321.706052 30,321.706052 Z M30,372.363112 L214.057743,372.363112 C217.371451,372.363112 220.057743,375.049404 220.057743,378.363112 L220.057743,384.685879 C220.057743,387.999587 217.371451,390.685879 214.057743,390.685879 L30,390.685879 C26.6862915,390.685879 24,387.999587 24,384.685879 L24,378.363112 C24,375.049404 26.6862915,372.363112 30,372.363112 Z M30,423.020173 L158.372703,423.020173 C161.686412,423.020173 164.372703,425.706464 164.372703,429.020173 L164.372703,435.342939 C164.372703,438.656648 161.686412,441.342939 158.372703,441.342939 L30,441.342939 C26.6862915,441.342939 24,438.656648 24,435.342939 L24,429.020173 C24,425.706464 26.6862915,423.020173 30,423.020173 Z M30,473.677233 L275.543307,473.677233 C278.857016,473.677233 281.543307,476.363525 281.543307,479.677233 L281.543307,486 C281.543307,489.313708 278.857016,492 275.543307,492 L30,492 C26.6862915,492 24,489.313708 24,486 L24,479.677233 C24,476.363525 26.6862915,473.677233 30,473.677233 Z M24,151.951009 L24,149.795389 L466,149.795389 L466,151.951009 L24,151.951009 Z M24,204.763689 L24,202.608069 L466,202.608069 L466,204.763689 L24,204.763689 Z M24,255.797983 L24,253.642363 L466,253.642363 L466,255.797983 L24,255.797983 Z M24,306.832277 L24,304.676657 L466,304.676657 L466,306.832277 L24,306.832277 Z M24,357.866571 L24,355.710951 L466,355.710951 L466,357.866571 L24,357.866571 Z M24,408.900865 L24,406.745245 L466,406.745245 L466,408.900865 L24,408.900865 Z M24,459.935159 L24,457.779539 L466,457.779539 L466,459.935159 L24,459.935159 Z"
                      fill="#D8D8D8"
                    />
                  </ContentLoader>
                </CardBody>
              </Card>
            );
          return (
            <PermissionDetails
              data={data}
              permissionDelete={() =>
                handlePermissionDelete({ variables: { ids: [id] } })
              }
            />
          );
        }}
      </this.Compose>
    );
  }
}

/**
 * PermissionDetailsContainer PropTypes
 * @param id - prop to know id of the Permission
 */
PermissionGroupDetailsContainer.propTypes = {
  id: PropTypes.string.isRequired,
};

export default PermissionGroupDetailsContainer;
